/**
 * @type {StoreDescriptor}
 */
export default {
  name: 'drafts',
  keyPath: ['id'],
  indexes: [['type', 'type'], ['date', 'date']],
}
